export default {
  title: "Notificaciones de staff",
  description: "Alertas operativas que requieren atención del staff.",
  empty: {
    title: "Sin notificaciones",
    description: "No hay notificaciones para los filtros seleccionados.",
    openOnly: "No hay notificaciones abiertas en este momento.",
  },
  filters: {
    status: "Estado",
    severity: "Gravedad",
    category: "Categoría",
    any: "Cualquiera",
  },
  statusTabs: {
    open: "Abiertas",
    acknowledged: "Reconocidas",
    resolved: "Resueltas",
    all: "Todas",
  },
  status: {
    open: "Abierta",
    acknowledged: "Reconocida",
    resolved: "Resuelta",
  },
  severity: {
    warning: "Advertencia",
    error: "Error",
    critical: "Crítica",
  },
  category: {
    payment: "Pago",
    booking: "Reserva",
    receipt: "Recibo",
    scheduler: "Programador",
    integration: "Integración",
    support: "Soporte",
    device: "Dispositivo",
    unknown: "Otra ({{value}})",
  },
  titles: {
    refund: {
      failed: "Reembolso fallido en el proveedor",
      rejected_handshake_failed: "Reembolso por rechazo de handshake fallido",
      retry_exhausted:
        "Reintentos de reembolso agotados — intervención manual requerida",
    },
    device: {
      low_battery: "Batería baja: {{displayLabel}} ({{batteryLevel}}%)",
      low_battery_kiosk: "Batería baja: Tablet {{kioskName}}",
      low_battery_kiosk_at_house: "Batería baja: Tablet {{kioskName}} en {{houseName}}",
      low_battery_reader: "Batería baja: Lector POS",
      low_battery_reader_at_house:
        "Batería baja: Lector POS en {{houseName}}, vinculado al kiosk {{kioskName}}",
      low_battery_reader_linked:
        "Batería baja: Lector POS vinculado al kiosk {{kioskName}}",
      low_battery_reader_at_house_only: "Batería baja: Lector POS en {{houseName}}",
    },
    booking: {
      created: "{{activityName}} — {{customerName}}",
      receipt: {
        manual_amount_registered: "Importe de recibo manual registrado por el partner",
      },
    },
    handshake: {
      notification_exhausted: "Notificaciones de handshake iniciales fallidas",
      message_blocked: "Mensaje de handshake bloqueado",
    },
    support: {
      ticket: {
        created: "Nuevo ticket de soporte ({{ticketNumber}})",
        partner_message: "Respuesta del partner en el ticket {{ticketNumber}}",
        notification_failed: "Notificación de ticket fallida ({{ticketNumber}})",
      },
    },
    customer_support: {
      chat: {
        message: "Mensaje de chat de soporte al cliente",
      },
    },
    test: {
      receipt: {
        warning: "[dev] Aviso de prueba de recibo",
      },
      refund: {
        failed: "[dev] Reembolso fallido en el proveedor",
      },
      manual: "Alerta de prueba",
    },
  },
  eventTypes: {
    refund: {
      failed: "Reembolso fallido",
      rejected_handshake_failed: "Reembolso por rechazo de handshake fallido",
      retry_exhausted: "Reintentos de reembolso agotados",
    },
    device: {
      low_battery: "Batería baja",
    },
    booking: {
      created: "Nueva reserva creada",
      receipt: {
        manual_amount_registered: "Importe de recibo manual registrado",
      },
    },
    handshake: {
      notification_exhausted: "Notificaciones de handshake fallidas",
      message_blocked: "Mensaje de handshake bloqueado",
    },
    support: {
      ticket: {
        created: "Nuevo ticket de soporte",
        partner_message: "Respuesta del partner en ticket",
        notification_failed: "Notificación de ticket fallida",
      },
    },
    customer_support: {
      chat: {
        message: "Mensaje de chat de soporte al cliente",
      },
    },
    test: {
      receipt: {
        warning: "Advertencia de recibo de prueba",
      },
      refund: {
        failed: "Fallo de reembolso de prueba",
      },
      manual: "Notificación manual de prueba",
    },
  },
  targetTypes: {
    booking: "Reserva",
    external_payment: "Pago externo",
    handshake_session: "Sesión de handshake",
    support_ticket: "Ticket de soporte",
    customer_support_chat: "Chat de soporte al cliente",
    device: "Dispositivo",
    reader: "Lector",
  },
  details: {
    eventType: "Evento",
    serialNumber: "Número de serie",
    target: "Objetivo",
    lastOccurred: "Última ocurrencia",
  },
  occurrences: "{{count}} ocurrencias",
  groups: {
    today: "Hoy",
    yesterday: "Ayer",
    older: "Anteriores",
  },
  audit: {
    acknowledged: "Reconocida por {{admin}} el {{date}}",
    resolved: "Resuelta por {{admin}} el {{date}}",
    unknownAdmin: "Staff desconocido",
  },
  card: {
    expand: "Expandir notificación: {{title}}",
    collapse: "Contraer notificación: {{title}}",
  },
  bulk: {
    selectAll: "Seleccionar todas en la página",
    selectOne: "Seleccionar {{title}}",
    selected: "{{count}} seleccionadas",
    pageCount: "{{count}} en la página",
    hint: "Selecciona varias y reconócelas o resuélvelas juntas",
    clearSelection: "Deseleccionar",
    acknowledge: "Reconocer",
    resolve: "Resolver",
    acknowledgeSuccess: "{{count}} notificaciones reconocidas",
    resolveSuccess: "{{count}} notificaciones resueltas",
    partialError: "{{count}} acciones fallidas",
  },
  actions: {
    openPayment: "Abrir pago",
    openBooking: "Abrir reserva",
    openHandshake: "Abrir handshake",
    openTicket: "Abrir ticket",
    openChat: "Abrir chat",
    openDevice: "Ir al dispositivo",
    openStructure: "Ir a la estructura",
    noLinks: "Sin recurso vinculado",
    acknowledge: "Reconocer",
    resolve: "Resolver",
    reopen: "Reabrir",
    acknowledgeSuccess: "Notificación reconocida",
    resolveSuccess: "Notificación resuelta",
    reopenSuccess: "Notificación reabierta",
    acknowledgeError: "No se pudo reconocer",
    resolveError: "No se pudo resolver",
    reopenError: "No se pudo reabrir",
  },
  pagination: "Página {{page}} de {{totalPages}} ({{total}} en total)",
  paginationSingle_one: "{{count}} notificación",
  paginationSingle_other: "{{count}} notificaciones",
} as const;
